export const getTotalAmount = (state) =>
  parseInt(state.formPage.priceValues.total || '0');

export const getSurcharges = (state) => state.formPage.quote?.quote?.surcharges;
